/** @jsxImportSource @emotion/react */

import { icons } from "assets/mobile";
import { BgSidebar } from "assets/mobile/images";
import { MenuSidebar } from "contants/menu-sidebar";
import { Link } from "react-router-dom";

import { SideBarMenuStyles } from "./index.style";

type Props = {
  isSidebar: boolean;
  onChangeSidebar: (val: boolean) => void;
};

function SideBarMenu({ isSidebar, onChangeSidebar }: Props) {
  return (
    <>
      <div css={SideBarMenuStyles.index(isSidebar)}>
        <div css={SideBarMenuStyles.header}>
          <icons.ArrowLeftSidebar onClick={() => onChangeSidebar(false)} />
        </div>
        <div css={SideBarMenuStyles.content}>
          <div css={SideBarMenuStyles.sidebarBg}>
            <img src={BgSidebar} alt="" />
          </div>
          <div css={SideBarMenuStyles.listMenu}>
            {MenuSidebar.map((item, index) => {
              return (
                <Link
                  key={`side-menu-${index}`}
                  css={SideBarMenuStyles.itemMenu}
                  to={item.link}
                >
                  <item.icon />
                  <span>{item.title}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
      <div
        onClick={() => onChangeSidebar(false)}
        css={SideBarMenuStyles.overlay(isSidebar)}
      />
    </>
  );
}

export default SideBarMenu;
